export * from "./useGetUserProperties";
export { default } from "./useGetUserProperties";
